<button
  mat-icon-button
  [disabled]="history?.length === 0"
  [matMenuTriggerFor]="historyMenu"
  matTooltip="Verlauf">
  <mat-icon>history</mat-icon>
</button>

<mat-menu #historyMenu>
  @for (entry of history; track entry) {
    <button mat-menu-item [routerLink]="entry.route">
      {{ entry.title }}
    </button>
  }
</mat-menu>
